import { businessPartnerOverviewStatusValues, businessPartnerOverviewTypeValues } from '@standandforce/api-contract';
import { z } from 'zod';
import { BusinessPartnerTableColumns } from './-constants';
export const BusinessPartnerTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.nativeEnum(BusinessPartnerTableColumns).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // ステータスタブ。初期表示は ACTIVE。空配列 = ALL（非 TERMINATED の既定表示）。
  businessPartnerStatusIn: z.array(z.enum(businessPartnerOverviewStatusValues)).default(['ACTIVE']),
  // フィルタ
  freeText: z.string().optional(),
  // タイプ絞り込み（法人 / 個人）。ステータスタブとは別の副次フィルタ。初期選択なし。
  businessPartnerTypeIn: z.array(z.enum(businessPartnerOverviewTypeValues)).optional()
});